// TODO: Once the paymentMethodTest AB test is finalized, move the schedule
// formatting (the ": " separator) into the back-end installments config and
// remove these helpers.

import { addToFormattedPrice } from './addToFormattedPrice';

const INSTALLMENT_ITEM_PREFIX = /^(\d+\.\s*rata):?\s*/i;

export const formatInstallmentScheduleItem = (item: string): string =>
  item.replace(INSTALLMENT_ITEM_PREFIX, '$1: ');

export const getInstallmentAmount = (item: string): string =>
  item.replace(INSTALLMENT_ITEM_PREFIX, '').trim();

export const addToInstallmentScheduleItem = (
  item: string,
  addition: number
): string => {
  const amount = getInstallmentAmount(item);

  return item.replace(amount, addToFormattedPrice(amount, addition));
};

export const pluralizeInstallments = (count: number): string => {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (count === 1) {
    return 'rata';
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return 'raty';
  }

  return 'rat';
};
